<template>
  <Spinner :loading="true">
    <div class="home" style="display: flex; align-items: center;">
      <Button @click="() => this.setGrade(0)">
        Младший
      </Button>
      <Button @click="() => this.setGrade(1)">
        Средний
      </Button>
      <Button @click="() => this.setGrade(2)">
        Старший
      </Button>

      <label>
        <input type="checkbox" v-model="debug" />
        Debug
      </label>
      <template v-if="debug">
        <Button @click="() => this.goTo('/lesson/1')">
          Улица
        </Button>
        <Button @click="() => this.goTo('/lesson/2')">
          Комната
        </Button>
        <Button @click="() => this.goTo('/lesson/3')">
          Робот
        </Button>
        <Button @click="() => this.goTo('/lesson/4')">
          Магазин
        </Button>
        <Button @click="() => this.goTo('/lesson/5')">
          Блог
        </Button>
        <Button @click="() => this.goTo('/lesson/6')">
          Вечеринка
        </Button>
        <Button @click="() => this.goTo('/poll')">
          Опрос
        </Button>
        <Button @click="() => this.goTo('/test')">
          Тест
        </Button>
        <Button @click="() => this.goTo('/dashboard')">
          Дэшборд
        </Button>
      </template>
    </div>
  </Spinner>
</template>

<script>
import { mapState } from 'vuex'
import Button from '@/components/@ui/Button/Button.vue'
import Spinner from '@/components/@ui/Spinner/Spinner.vue'

export default {
  name: 'home',
  data: () => ({
    debug: false,
  }),
  components: { Button, Spinner },
  methods: {
    setGrade(grade) {
      this.$store.commit('setGrade', grade)
      this.$userStory.setGrade(grade).next()
    },
    goTo(path) {
      this.$router.push(path)
    },
  },
  computed: {
    ...mapState(['grade']),
  },
  watch: {
    debug(debug) {
      this.$store.commit('setGrade', debug)
    },
  },
  created() {
    const userID = this.$route.params.userID || this.$route.query.user_id
    if (userID) {
      this.$store.commit('setUserID', { userID })
      this.$store.dispatch('getUser', { userID })
        .then(() => {
          const user = this.$store.getters.userObj
          this.setGrade(user.age_group - 1)
        })
    }
    // this.$router.push('/lesson/1')
  },
}
</script>
<style lang="scss">
.home{
  height: 100vh;
  & > * {
    opacity: 0;
    pointer-events: none;
  }
}
</style>
